import React from 'react'
import { Link } from 'react-router-dom'
import { WalletComponent } from '../rightSide/walletComponent/WalletComponent'
import Logo from '../icons/logo'
import { MobileContainer, LogoContainer, WalletWrapper } from './AppTop.styled'
import { AuthViewProps } from './AppTop.interface'
import { AuthSection } from './AppTop.auth'

export const MobileView: React.FC<AuthViewProps> = (props) => (
  <MobileContainer>
    <LogoContainer>
      <Link to="/">
        <Logo className="text-white w-54" />
      </Link>
    </LogoContainer>
    <WalletWrapper>
      <WalletComponent />
    </WalletWrapper>
    <AuthSection {...props} />
  </MobileContainer>
)
